module.exports = __webpack_public_path__ + "img/soccer_field_FBASE.0f8ad06c.png";